<script>
import {
  mapActions
} from 'vuex'

import CandelaControl from '@/components/controls/CandelaControl'

export default {
  extends: CandelaControl,
  methods: {
    ...mapActions([
      'send_control_value'
    ])
  },
  name: 'candela-button',
  props: {
    icon: {type: String, default: () => null}
  }
}
</script>
<template>
<div class='candela-button align-self-stretch align-center flex-grow-0'>
  <div v-if='icon' class='d-flex flex-column justify-center align-center'>
    <v-btn @click='send_control_value({id, component_id, type})'
      color='primary' class='mb-2' icon outlined>
      <candela-icon color='primary' :name='icon' :icon_props='{small: true}'/>
    </v-btn>
    <div v-if='label' class='font-weight-bold overline primary--text'>
      {{label}}
    </div>
  </div>
  <v-btn v-else @click='send_control_value({id, component_id, type})'
    color='primary' outlined>{{label}}</v-btn>
</div>
</template>

<style lang='sass' scoped>
::v-deep .v-btn
  flex-grow: 1

::v-deep .v-btn--icon
  flex-grow: 0
</style>
